import { defineComponent as v, ref as C, computed as I, createBlock as n, openBlock as r, unref as l, withModifiers as y, withCtx as a, renderSlot as m, createTextVNode as w, toDisplayString as k, createElementVNode as g, normalizeClass as h, createCommentVNode as B } from "vue";
import { componentHasFocus as N } from "../InputSelect.helpers.js";
import { RevListItemInteractive as V } from "@ds/components/ListItemInteractive";
import { usePropsValidation as $ } from "../../../composables/usePropsValidation.js";
import z from "../../../icons/generated/IconCheckLarge.vue2.js";
import { tw as o } from "../../../utils/tailwind.js";
const H = /* @__PURE__ */ v({
  name: "RevInputSelectItem",
  __name: "InputSelectItem",
  props: {
    option: {},
    label: {},
    isSelected: { type: Boolean },
    id: { default: "" },
    itemsCenter: { type: Boolean, default: !1 }
  },
  emits: ["select"],
  setup(p, { expose: d, emit: f }) {
    const t = p, c = f;
    $({
      "The id prop is required if options are of type `OptionItem`": () => !t.option.id && !t.id
    });
    const i = C(null);
    function u(e) {
      c("select", e);
    }
    function b() {
      const e = i.value;
      e && N(e) && e.focus();
    }
    d({ focus: b });
    const S = I(() => [
      o`rounded-sm pointer-events-none mt-2 flex size-20 items-center justify-center ease-in motion-safe:transition-colors motion-safe:duration-[50ms]`,
      !t.isSelected && o`bg-action-default-low border-static-default-hi border`,
      t.isSelected && o`bg-action-default-low-pressed text-onaction-default-low-pressed`
    ]);
    return (e, s) => (r(), n(l(V), {
      id: e.option.id || e.id,
      ref_key: "listItem",
      ref: i,
      "aria-label": e.label,
      "aria-selected": e.isSelected,
      class: "group",
      "items-center": e.itemsCenter,
      role: "option",
      onClick: s[0] || (s[0] = y((R) => u(e.option), ["prevent"]))
    }, {
      prefix: a(() => [
        m(e.$slots, "prefix", {}, () => [
          g("div", {
            class: h(S.value)
          }, [
            e.isSelected ? (r(), n(l(z), {
              key: 0,
              size: "16"
            })) : B("", !0)
          ], 2)
        ])
      ]),
      label: a(() => [
        m(e.$slots, "label", {}, () => [
          w(k(e.label), 1)
        ])
      ]),
      _: 3
    }, 8, ["id", "aria-label", "aria-selected", "items-center"]));
  }
});
export {
  H as default
};
